import { useEffect, useState } from "react";
import { motion, useAnimationControls } from "framer-motion";

export default function BookButterfly({
    testid = "book-butterfly",
    className = "-top-4 right-[10%] w-9 sm:-top-5 sm:w-11",
    delay = 3,
    restRange = [900, 1500],
}) {
    const controls = useAnimationControls();
    const [flying, setFlying] = useState(true);

    useEffect(() => {
        let alive = true;
        const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

        const run = async () => {
            setFlying(true);
            await controls.start({
                x: [280, 70, 0],
                y: [-160, -64, 0],
                opacity: [0, 1, 1],
                rotate: [16, -8, 0],
                transition: { duration: 4.4, delay, times: [0, 0.62, 1], ease: "easeInOut" },
            });
            if (!alive) return;
            setFlying(false);
            while (alive) {
                await sleep(restRange[0] + Math.random() * (restRange[1] - restRange[0]));
                if (!alive) break;
                setFlying(true);
                await controls.start({
                    x: [0, 120, -90, 40, 0],
                    y: [0, -80, -130, -70, 0],
                    rotate: [0, 14, -12, 8, 0],
                    transition: { duration: 6.5, ease: "easeInOut" },
                });
                if (!alive) break;
                setFlying(false);
            }
        };
        run();
        return () => {
            alive = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <motion.div
            data-testid={testid}
            data-flying={flying}
            className={`pointer-events-none absolute z-20 ${className}`}
            initial={{ x: 280, y: -160, opacity: 0, rotate: 16 }}
            animate={controls}
        >
            <svg viewBox="0 0 40 36" className="block w-full drop-shadow-[0_2px_6px_rgba(0,0,0,0.5)]">
                <g className={`wing wing-left ${flying ? "" : "perch-wing-left"}`}>
                    <ellipse cx="11" cy="13" rx="10" ry="13" fill="#f3e5ab" opacity="0.95" />
                    <ellipse cx="13" cy="27" rx="6" ry="7" fill="#d4af37" opacity="0.9" />
                </g>
                <g className={`wing wing-right ${flying ? "" : "perch-wing-right"}`}>
                    <ellipse cx="29" cy="13" rx="10" ry="13" fill="#f3e5ab" opacity="0.95" />
                    <ellipse cx="27" cy="27" rx="6" ry="7" fill="#d4af37" opacity="0.9" />
                </g>
                <rect x="18.6" y="5" width="2.8" height="26" rx="1.4" fill="#3a2c14" />
            </svg>
        </motion.div>
    );
}
